"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomEnteredEventArgs = void 0;
const EventType_1 = require("../EventType");
class RoomEnteredEventArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = EventType_1.EventType.RoomEntered;
        this.__typeName = "RoomEntered";
    }
}
exports.RoomEnteredEventArgs = RoomEnteredEventArgs;
